import { ArrowSquareOut, BookOpenText, SealCheck } from "@phosphor-icons/react";

const ACCENT = {
  saffron: {
    stripe: "bg-saffron",
    band: "bg-saffron/15 text-saffron-hover border-saffron",
    title: "group-hover:text-saffron-hover",
    icon: "text-saffron-hover",
  },
  indigo: {
    stripe: "bg-indigo",
    band: "bg-indigo/10 text-indigo border-indigo",
    title: "group-hover:text-indigo",
    icon: "text-indigo",
  },
  terracotta: {
    stripe: "bg-terracotta",
    band: "bg-terracotta/10 text-terracotta border-terracotta",
    title: "group-hover:text-terracotta",
    icon: "text-terracotta",
  },
  teal: {
    stripe: "bg-teal",
    band: "bg-teal/10 text-teal border-teal",
    title: "group-hover:text-teal",
    icon: "text-teal",
  },
};

export const FeaturedBooks = ({ books = [] }) => {
  if (!books.length) return null;
  return (
    <div data-testid="featured-books" className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
      {books.map((b, i) => {
        const palette = ACCENT[b.accent] || ACCENT.saffron;
        return (
          <a
            key={b.isbn || i}
            href={b.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`featured-book-${i}`}
            className="editorial-card relative overflow-hidden group flex flex-col sm:flex-row gap-0 bg-white"
          >
            <div className={`absolute top-0 left-0 h-1 w-full ${palette.stripe}`} />
            <div className="sm:w-[42%] shrink-0 bg-paper-alt overflow-hidden">
              <div className="aspect-square sm:aspect-auto sm:h-full">
                <img
                  src={b.cover_image}
                  alt={`${b.title} — book cover`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  data-testid={`featured-book-cover-${i}`}
                  loading="lazy"
                />
              </div>
            </div>
            <div className="p-6 lg:p-7 flex-1 flex flex-col">
              <div className="flex items-center gap-2 mb-3">
                <BookOpenText size={18} weight="duotone" className={palette.icon} />
                <span className={`pill-color text-[10px] py-1 ${palette.band}`}>
                  Editor · In print
                </span>
              </div>
              <div className="overline mb-2">{b.tagline}</div>
              <h3
                className={`font-display text-xl lg:text-2xl tracking-tight leading-tight transition-colors ${palette.title}`}
              >
                {b.title}
              </h3>
              <div className="text-sm text-ink-mute italic mt-2 leading-snug">
                Edited with {b.co_editors?.filter((e) => !e.toLowerCase().includes("partha")).join(", ")}
              </div>
              <div className="mt-auto pt-5 flex items-center justify-between flex-wrap gap-2">
                <div className="flex items-center gap-3 font-mono text-[11px] text-ink-mute uppercase tracking-wider">
                  <span className="flex items-center gap-1">
                    <SealCheck size={12} weight="fill" className="text-teal" />
                    Scopus
                  </span>
                  <span>·</span>
                  <span>{b.publisher}</span>
                  <span>·</span>
                  <span>{b.pages} pp</span>
                </div>
                <span className={`inline-flex items-center gap-1 text-xs font-mono uppercase tracking-wider ${palette.icon}`}>
                  Open <ArrowSquareOut size={12} weight="bold" />
                </span>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default FeaturedBooks;
